<template>
    <div>
        <div class="margin-bottom-10">
            <slot name="headline-category"></slot>
            <slot name="form-category"></slot>
        </div>
        <div class="margin-bottom-10">
            <div
                ref="subCategoryFormElement"
                v-html="subCategoryForm"></div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        props: {
            label: { type: String, default: '' },
            placeholder: { type: String, default: '' },
            ajaxFormPath: { type: String, default: '' },
            mainCategories: { type: Array, default: () => [] },
            formId: { type: String, required: false },
            isDisabled: { type: Boolean, default: false },
        },
        data() {
            return {
                selectedCategory: 0,
                subCategoryForm: '',
            };
        },
        computed: {
            submittedSubCategory() {
                if (Object.prototype.hasOwnProperty.call(this.$store.state.searchQueryParameters, 'subCategory')) {
                    return parseInt(this.$store.state.searchQueryParameters.subCategory);
                }

                return 0;
            },
        },
        methods: {
            updateCategory() {
                this.selectedCategory = parseInt(this.$slots['form-category'][0].elm.querySelector('select').value);

                if (this.selectedCategory === 0) {
                    this.subCategoryForm = '';

                    return;
                }

                const data = new FormData();
                data.append('category', this.selectedCategory);

                axios({
                    method: 'post',
                    url: this.ajaxFormPath,
                    responseType: 'text',
                    data: data,
                }).then(response => {
                    if (response !== '' && response.data) {
                        this.subCategoryForm = response.data;
                        setTimeout(() => {
                            this.updateSubCategory();
                        }, 0);
                    }
                }).catch(error => {
                    console.error(error);
                });
            },
            bindCategoryEventListener() {
                this.$slots['form-category'][0].elm.querySelector('select').addEventListener('change', () => {
                    this.updateCategory();
                });
            },
            bindResetEventListener() {
                document.querySelector('[data-entityfilter]').addEventListener('reset', () => {
                    this.resetAll();
                });
            },
            resetAll() {
                this.$slots['form-category'][0].elm.querySelector('select').value = 0;
                this.updateCategory();
            },
            updateSubCategory() {
                this.$refs.subCategoryFormElement.querySelector('#subCategory').value = this.submittedSubCategory;
            },
        },
        mounted() {
            this.bindCategoryEventListener();
            this.updateCategory();
            this.bindResetEventListener();
        },
    };

</script>
